import { useEffect, useState } from "react"
import { useParams, useNavigate } from "react-router-dom";
import { PageLoader } from "@/components/ui/page-loader"
import { useEmailCampaigns } from "@crm-src/hooks/useEmailCampaigns"
import { useToast } from "@crm-src/hooks/use-toast"
import { type EmailCampaign } from "@crm-src/lib/store/campaignsSlice"
import EmailCampaignForm from "@crm-src/components/email-campaign-form"
import { emailCampaignsPath } from "@crm-src/lib/email-campaign-routes"

export default function EditEmailCampaignPage() {
  const params = useParams()
  const navigate = useNavigate()
  const { toast } = useToast()
  const { fetchCampaign } = useEmailCampaigns()
  const [campaign, setCampaign] = useState<EmailCampaign | null>(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const loadCampaign = async () => {
      try {
        setIsLoading(true)
        const id = params.id as string
        const loadedCampaign = await fetchCampaign(id)
        
        if (!loadedCampaign) {
          toast({
            title: "Error",
            description: "Campaign not found",
            variant: "destructive",
          })
          navigate(emailCampaignsPath())
          return
        }
        
        setCampaign(loadedCampaign)
      } catch (error: any) {
        toast({
          title: "Error",
          description: error.message || "Failed to load campaign",
          variant: "destructive",
        })
        navigate(emailCampaignsPath())
      } finally {
        setIsLoading(false)
      }
    }

    if (params.id) {
      loadCampaign()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params.id])

  if (isLoading) {
    return <PageLoader />
  }

  if (!campaign) {
    return null
  }

  return <EmailCampaignForm existingCampaign={campaign} />
}

